module.exports = __webpack_public_path__ + "static/media/hilux5.9e6327fb.webp";